import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Jibek Jolu Group — Since 2009';
render(<App data-id="element-284" />, document.getElementById('root'));